import types from './types';

const getCenterTimecards = () => ({
  type: types.GET_TODAY_CENTER_TIMECARDS_REQUEST
});

/**
 *
 * @param {Object[]} todayTimecards
 * @param {Object} byEmployee
 */
const getCenterTimecardsSuccess = (todayTimecards, byEmployee) => ({
  type: types.GET_TODAY_CENTER_TIMECARDS_SUCCESS,
  todayTimecards,
  byEmployee
});

const getCenterTimecardsFailure = error => ({
  type: types.GET_TODAY_CENTER_TIMECARDS_FAILURE,
  error
});

const getEmployeeTimecardsInRange = (
  employeeId,
  start,
  end
) => ({
  type: types.GET_EMPLOYEE_TIMECARDS_IN_RANGE_REQUEST,
  employeeId,
  start,
  end
});

const getEmployeeTimecardsInRangeSuccess = timecards => ({
  type: types.GET_EMPLOYEE_TIMECARDS_IN_RANGE_SUCCESS,
  timecards
});

const getEmployeeTimecardsInRangeFailure = error => ({
  tyoe: types.GET_EMPLOYEE_TIMECARDS_IN_RANGE_FAILURE,
  error
});

const setEditsToTimecard = (timecardId, start, end) => ({
  type: types.SET_EDITS_TO_TIMECARD,
  timecardId,
  start,
  end
});

const updateTimecardsRequest = () => ({
  type: types.UPDATE_TIMECARDS_REQUEST
});

const updateTimecardsSuccess = timecardUpdates => ({
  type: types.UPDATE_TIMECARDS_SUCCESS,
  timecardUpdates
});

const updateTimecardsFailure = () => ({
  type: types.UPDATE_TIMECARDS_FAILURE
});

export default {
  getCenterTimecards,
  getCenterTimecardsSuccess,
  getCenterTimecardsFailure,
  getEmployeeTimecardsInRange,
  getEmployeeTimecardsInRangeSuccess,
  getEmployeeTimecardsInRangeFailure,
  setEditsToTimecard,
  updateTimecardsRequest,
  updateTimecardsSuccess,
  updateTimecardsFailure
};
